module.exports = __webpack_public_path__ + "static/img/s26.b6491b77.png";